import type { ViewQueryField, ViewQueryList } from '@salescore/core'
import { useMemo } from 'react'

export const useSearchableFields = (query: ViewQueryList): ViewQueryField[] => {
  const { fields } = query
  return useMemo(() => fields.filter((field) => field.meta.searchable === true), [fields])
}
